import { render, staticRenderFns } from "./PDFViewer2.vue?vue&type=template&id=0f33c91b&scoped=true&"
import script from "./PDFViewer2.vue?vue&type=script&lang=js&"
export * from "./PDFViewer2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33c91b",
  null
  
)

export default component.exports